import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { AccountInfo as MsalUser } from '@azure/msal-browser';

export interface AuthState {
  authService: MsalService;
  broadcastService: MsalBroadcastService;
  loggedIn: boolean;
  userInfo: MsalUser;
}

export const initialAuthState: AuthState = {
  authService: null,
  broadcastService: null,
  loggedIn: false,
  userInfo: null
};
